import React from 'react';

import PropTypes from 'prop-types';

import style from './ModalCommon.module.scss';

function ModalCommonContent({children}) {
  return <div className={style.content}>{children}</div>;
}

export default ModalCommonContent;

ModalCommonContent.propTypes = {
  children: PropTypes.node.isRequired,
};
